import { render } from "./PostTextAgentForm.vue?vue&type=template&id=bff264c6"
import script from "./PostTextAgentForm.vue?vue&type=script&lang=js"
export * from "./PostTextAgentForm.vue?vue&type=script&lang=js"

import "./PostTextAgentForm.vue?vue&type=style&index=0&id=bff264c6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__